export default "/_next/static/images/caregiver4-0bebe4cc960c734dda8ea16c0e3e4186.png";